export default __webpack_public_path__ + "static/media/redirect-to-top-icon.1b741acb.svg";